import { render, staticRenderFns } from "./printstickerin.vue?vue&type=template&id=7ffe48f4&"
import script from "./printstickerin.vue?vue&type=script&lang=js&"
export * from "./printstickerin.vue?vue&type=script&lang=js&"
import style0 from "./printstickerin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports